import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_PRICING_INSIGHTS_QUERY_KEY } from './useGetPricingInsights';

export type ApplyPricingChangeInput = {
    pricingIds: string[];
    newPrice: number;
};

export type PricingChangeResult = {
    pricingId: string;
    courtName: string;
    sport: string;
    capacity: number;
    oldPrice: number;
    newPrice: number;
    changePercent: number;
    currency: string;
    warning?: string;
    updatedCount: number;
};

export const useApplyPricingChange = (
    organizationId: string,
    locationId: string,
    onSuccess: (result: PricingChangeResult) => void,
    onError?: () => void,
) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['applyPricingChange'],
        mutationFn: (body: ApplyPricingChangeInput) =>
            apiClient.fetchApi<PricingChangeResult, ApplyPricingChangeInput>({
                method: 'POST',
                endpoint: `court-pricing/apply-pricing-change?organizationId=${organizationId}`,
                body,
            }),
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: GET_PRICING_INSIGHTS_QUERY_KEY(locationId),
            });
            onSuccess(data);
        },
        onError: () => {
            onError?.();
        },
    });
};
